import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Polygon from './views/Polygon.vue'
import Togo from './views/Togo.vue'
import Foods from './views/Foods.vue'
import AllShops from './views/AllShops.vue'
import Orders from './views/Orders.vue'
import Shopping from './views/Shopping.vue'
import Info from './views/Shop.vue'

Vue.use(Router)

// export default new Router({

let root = Home;

switch (GLOBAL_TABS.charAt(0)) {
  case 't':
    root = Togo;
    break;
  case 'd':
    root = Home;
    break;
  case 'p':
    root = Polygon;
    break;
  case 'o':
    root = Orders;
    break;
  case 'f':
    root = Foods;
    break;
  case 'a':
    root = AllShops;
    break;
  case 'r':
    root = Shopping;
    break;
  case 'i':
    root = Info;
    break;
  default:
    root = Home;
    break;
}
// console.log('HiHIHi the route checking ' + GLOBAL_TABS);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: { auth: true },
      component: root
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/delivery',
      name: 'Delivery',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Home
    },
    {
      path: '/deliveryp',
      name: 'Delivery',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Polygon
    },
    {
      path: '/togo',
      name: 'Togo',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Togo.vue')
    },
    {
      path: '/foods',
      name: 'Foods',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Foods.vue')
    },
    {
      path: '/all-shops',
      name: 'AllShops',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/AllShops.vue')
    },
    {
      path: '/shopping',
      name: 'Shopping',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Shopping.vue')
    },
    {
      path: '/shopping/:shopId',
      name: 'shopping.ShopInfo',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Shop.vue')
    },
    {
      path: '/info',
      name: 'shopping.ShopInfo',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Shop.vue')
    },
    {
      path: '/delivery/:shopId',
      name: 'delivery.ShopInfo', // footer是根據footer來亮，所以命名要階層
      meta: { auth: true, backTo: '/' },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Shop.vue')
    },
    {
      path: '/togo/:shopId',
      name: 'togo.ShopInfo', // footer是根據footer來亮，所以命名要階層
      meta: { auth: true, backTo: '/togo' },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Shop.vue')
    },
    {
      path: '/foods/:shopId',
      name: 'foods.ShopInfo', // footer是根據footer來亮，所以命名要階層
      meta: { auth: true, backTo: '/foods' },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Shop.vue')
    },
    {
      path: '/all-shops/:shopId',
      name: 'allShops.ShopInfo', // footer是根據footer來亮，所以命名要階層
      meta: { auth: true, backTo: '/all-shops' },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Shop.vue')
    },
    {
      path: '/orders',
      name: 'orders.SearchOrders', // 前面的orders必要，因為靠這個來控制footer
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Orders.vue')
    },
    {
      path: '/orders/:orderId',
      name: 'orders.OrderNumber',
      meta: { backTo: '/orders', auth: true, showId: 'orderId' },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Order.vue')
    },
    {
      path: '/line-orders/:orderId',
      name: 'orders.OrderNumber',
      meta: { showId: 'orderId' },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/LineOrder.vue')
    },
    {
      path: '/web-orders',
      name: 'orders.SearchOrders',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/WebOrders.vue')
    },
    {
      path: '/web-orders/:orderId',
      name: 'orders.OrderNumber',
      meta: { backTo: '/web-orders', auth: true, showId: 'orderId' },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/WebOrder.vue')
    },
    {
      path: '/web-userdata',
      name: 'settings.Userdata',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/WebUserData.vue')
    },
    {
      path: '/line-shops/:shopId',
      name: 'Shop',
      meta: {},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/LineShop.vue')
    },
    {
      path: '/qr-shops/:shopId',
      name: 'Shop',
      meta: {},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/QrShop.vue')
    },
    {
      path: '/settings',
      name: 'Settings',
      meta: { auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Settings.vue')
    },
    {
      path: '/userdata',
      name: 'settings.Userdata',
      meta: { backTo: '/settings', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/UserData.vue')
    },
    {
      path: '/mobile-edit',
      name: 'settings.MobileEdit',
      meta: { backTo: '/userdata', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/MobileEdit.vue')
    },
    {
      path: '/web-mobile-edit',
      name: 'settings.MobileEdit',
      meta: { backTo: '/web-userdata', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/WebMobileEdit.vue')
    },
    {
      path: '/name-edit',
      name: 'settings.NameEdit',
      meta: { backTo: '/userdata', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/NameEdit.vue')
    },
    {
      path: '/web-name-edit',
      name: 'settings.NameEdit',
      meta: { backTo: '/web-userdata', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/WebNameEdit.vue')
    },
    {
      path: '/address-edit',
      name: 'settings.AddressEdit',
      meta: { backTo: '/userdata', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/AddressEdit.vue')
    },
    {
      path: '/address-edit/:addressId',
      name: 'settings.AddressEdit',
      meta: { backTo: '/userdata', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/AddressEdit.vue')
    },
    {
      path: '/web-address-edit',
      name: 'settings.AddressEdit',
      meta: { backTo: '/web-userdata', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/WebAddressEdit.vue')
    },
    {
      path: '/web-address-edit/:addressId',
      name: 'settings.AddressEdit',
      meta: { backTo: '/web-userdata', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/WebAddressEdit.vue')
    },
    {
      path: '/notify',
      name: 'settings.Notification',
      meta: { backTo: '/settings', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/LineNotify.vue')
    },
    {
      path: '/pushlist',
      name: 'settings.Pushlist',
      meta: { backTo: '/settings', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/PushList.vue')
    },
    {
      path: '/services',
      name: 'settings.CustomerServices',
      meta: { backTo: '/settings', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/CustomerServices.vue')
    },
    {
      path: '/system',
      name: 'settings.System',
      meta: { backTo: '/settings', auth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/System.vue')
    },
    {
      path: '/qcmoney',
      name: 'settings.System',
      meta: { backTo: '/settings', auth: true},
      component: () => import('./views/QCMoney.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  // const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  // if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  if (!to.query.p) {
    to.query.p = process.env.VUE_APP_DEFAULT_PORTAL; // default portal

    next({ path: to.path, query: to.query });
    //next({ path: to.path, query: query });
  } else {
    next();
  }


});

export default router;
